import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Slider from '@material-ui/core/Slider';

import { RANGE_FILTERS } from '../constants';
import { useStyles, useSliderStyles } from './styles';
import filterbarSlice from '../filterbarSlice';
import CustomValueLabel from './CustomValueLabel';

const RangeFilters = () => {
	const classes = useStyles();
	const sliderStylesClasses = useSliderStyles();
	const rangeFiltersMinMax = useSelector(state => state.designList.rangeFiltersMinMax);
	const rangeFilterValues = useSelector(state => state.filterbar.rangeFilterValues);
	const [localRFValues, setLocalRFValues] = useState(rangeFilterValues);
	const dispatch = useDispatch();

	const firstValueFilterName = Object.keys(rangeFiltersMinMax)[0];
	const isStatePrepared =
		rangeFiltersMinMax[firstValueFilterName] &&
		rangeFiltersMinMax[firstValueFilterName].marks &&
		localRFValues[firstValueFilterName] &&
		localRFValues[firstValueFilterName].values;

	useEffect(() => {
		if (JSON.stringify(localRFValues) !== JSON.stringify(rangeFilterValues)) {
			setLocalRFValues(rangeFilterValues);
		}
	}, [rangeFilterValues]);

	const handleRangeFilterChangeComitted = filterName => (_event, value) => {
		dispatch(
			filterbarSlice.actions.changeRangeFilterValues({
				filter: filterName,
				values: value
			})
		);
	};

	const handleRangeFilterChange = filterName => (_event, value) => {
		setLocalRFValues({
			...localRFValues,
			[filterName]: { ...localRFValues[filterName], values: value }
		});
	};

	return (
		<Grid container direction="column" className={classes.rangeSlidersContent}>
			{isStatePrepared &&
				Object.keys(rangeFiltersMinMax).map(rfName => {
					const rangeFilter = RANGE_FILTERS.find(rf => rf.name === rfName);
					const sliderLabelId = 'range-slider-' + rfName;

					return rangeFilter ? (
						<Grid item container direction="row" key={rangeFilter.name + rangeFilter.label}>
							<Grid item className={classes.rangeSlidersList}>
								<Typography id={sliderLabelId} variant="body2" display="inline">
									{rangeFilter.label}
								</Typography>

								<Typography color="textSecondary" variant="body2" display="inline">
									{'\u00a0' + rangeFilter.unit}
								</Typography>
							</Grid>

							<Grid item className={classes.rangeSlidersList}>
								<Slider
									color="secondary"
									valueLabelDisplay="on"
									ValueLabelComponent={CustomValueLabel}
									aria-labelledby={sliderLabelId}
									marks={rangeFiltersMinMax[rangeFilter.name].marks}
									step={1}
									min={rangeFiltersMinMax[rangeFilter.name].min}
									max={rangeFiltersMinMax[rangeFilter.name].max}
									value={[...localRFValues[rangeFilter.name].values]}
									onChange={handleRangeFilterChange(rangeFilter.name)}
									onChangeCommitted={handleRangeFilterChangeComitted(rangeFilter.name)}
									classes={sliderStylesClasses}
								/>
							</Grid>
						</Grid>
					) : null;
				})}
		</Grid>
	);
};

export default RangeFilters;
